import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import LogoComponent from "./LogoComponent";
import { AlignJustify } from "lucide-react";

const Navbar = () => {
  const location = useLocation();
  const { confirm } = Modal;
  const [token, setToken] = useState(null);
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navbarRef = useRef(null);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/");
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      const name = localStorage.getItem("userName");
      setUserName(name);
      setToken(accessToken);
    }
  }, []);

  // Toggle navbar collapse
  const toggleNav = () => {
    setIsNavOpen((prev) => !prev);
  };

  // Close navbar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsNavOpen(false);
      }
    };

    // Use capture phase to ensure all clicks are caught
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, []);

  // Close navbar when a menu item is clicked
  const handleMenuItemClick = () => {
    setIsNavOpen(false);
  };

  return (
    <header
      className="text-white py-3"
      style={{ position: "sticky", top: 0, width: "100%", zIndex: 1040 }}
    >
      <nav
        className="navbar navbar-expand-lg bg-black text-white text-center pe-md-2"
        ref={navbarRef}
      >
        <div className="container">
          <LogoComponent />
          <div
            className="d-flex align-items-center"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            <h3 className="m-0 fw-bold fs-3" id="main-font">
              ProSlay
            </h3>
          </div>
          {/* <div className="pe-3"> */}
          <button
            type="button"
            className="navbar-toggler"
            onClick={toggleNav}
            aria-controls="navbar"
            aria-expanded={isNavOpen}
            aria-label="Toggle navigation"
          >
            <AlignJustify
              className="nav-icon"
              size={20}
              style={{ color: "#fff" }}
            />
          </button>
          {/* </div> */}
          <div
            id="navbar"
            className={`navbar-collapse collapse ${
              isNavOpen ? "show" : ""
            } d-lg-flex justify-content-lg-end`}
          >
            <ul className="navbar-nav">
              <li className="custom-nav-item dropdown">
                <button
                  className={`nav-link m-auto dropdown-toggle ${
                    ["/founder", "/ai", "/about"].includes(location.pathname)
                      ? "active text-white fw-bolder"
                      : ""
                  }`}
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  About Us
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      className={`dropdown-item ${
                        location.pathname === "/about" ? "active fw-bold" : ""
                      }`}
                      to="/about"
                      onClick={handleMenuItemClick}
                    >
                      Company
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item ${
                        location.pathname === "/founder" ? "active fw-bold" : ""
                      }`}
                      to="/founder"
                      onClick={handleMenuItemClick}
                    >
                      Founder
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`dropdown-item ${
                        location.pathname === "/ai" ? "active fw-bold" : ""
                      }`}
                      to="/ai"
                      onClick={handleMenuItemClick}
                    >
                      AI
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="custom-nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/services"
                      ? "active text-white fw-bolder"
                      : ""
                  }`}
                  to="/services"
                  onClick={handleMenuItemClick}
                >
                  Services
                </Link>
              </li>
              <li className="custom-nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/howItWorks"
                      ? "active text-white fw-bolder"
                      : ""
                  }`}
                  to="/howItWorks"
                  onClick={handleMenuItemClick}
                >
                  How It Works
                </Link>
              </li>
              <li className="custom-nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/requestcall"
                      ? "active text-white fw-bolder"
                      : ""
                  }`}
                  to="/requestcall"
                  onClick={handleMenuItemClick}
                >
                  Request a Call
                </Link>
              </li>
              <li className="custom-nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/legalservices"
                      ? "active text-white fw-bolder"
                      : ""
                  }`}
                  to="/legalservices"
                  onClick={handleMenuItemClick}
                >
                  Legal Services
                </Link>
              </li>
              {/* <li className="custom-nav-item">
                <Link
                  className={`nav-link ${location.pathname === "/founder"
                      ? "active text-white fw-bolder"
                      : ""
                    }`}
                  to="/founder"
                >
                  Founder
                </Link>
              </li>
              <li className="custom-nav-item">
                <Link
                  className={`nav-link ${location.pathname === "/ai"
                      ? "active text-white fw-bolder"
                      : ""
                    }`}
                  to="/ai"
                >
                  AI
                </Link>
              </li> */}
              {token && (
                <li className="custom-nav-item" onClick={handleMenuItemClick}>
                  <Link
                    className={`nav-link ${
                      location.pathname === "/dashboard"
                        ? "active text-white fw-bolder"
                        : ""
                    }`}
                    to="/dashboard"
                  >
                    Dashboard
                  </Link>
                </li>
              )}
            </ul>
          </div>
          {token ? (
            <ul className="navbar-nav ml-auto">
              <li className="custom-nav-item d-flex align-items-center mx-4">
                <span className="">
                  <img
                    src="/assets/img/userImg.jpg"
                    alt=""
                    className="img-circle"
                  />
                </span>
                <div className="ms-1 custom-nav-item dropdown d-inline-block">
                  <a
                    className="nav-link d-flex align-items-center"
                    data-toggle="dropdown"
                    href="/"
                  >
                    <h5 className="header-font mb-0 text-white" id="main-font">
                      {userName}
                    </h5>
                  </a>
                  <div className="dropdown-menu custom-dropdown p-0 w-auto">
                    <div className="border-bottom">
                      <Link
                        to="/profile"
                        className="text-decoration-none logout-font d-block ps-3 p-1"
                        onClick={handleMenuItemClick}
                      >
                        MY PROFILE
                      </Link>
                    </div>
                    <div className="border-bottom">
                      <Link
                        to="/account-configuration"
                        className="text-decoration-none logout-font d-block ps-3 p-1"
                        onClick={handleMenuItemClick}
                      >
                        CONFIGURATIONS
                      </Link>
                    </div>
                    <div>
                      <Link
                        className="text-decoration-none logout-font p-1 d-block"
                        onClick={() => {
                          confirm({
                            title: (
                              <div style={{ position: "relative" }}>
                                <span>Are you sure you want to log out?</span>
                                <CloseOutlined
                                  style={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-10px",
                                  }}
                                  onClick={() => {
                                    Modal.destroyAll();
                                  }}
                                />
                              </div>
                            ),
                            okText: "YES",
                            okType: "default",
                            cancelText: "NO",
                            onOk() {
                              handleLogout();
                            },
                            onCancel() {
                              console.log("Cancel");
                            },
                          });
                        }}
                      >
                        LOGOUT
                      </Link>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          ) : (
            <div className="ms-auto">
              <Link
                className="btn btn-outline-light btn-sm mx-1 px-3 py-2"
                type="submit"
                to="/login"
                id="main-font"
                onClick={handleMenuItemClick}
              >
                Login
              </Link>
              <Link
                className="btn btn-light btn-sm mx-1 px-3 py-2"
                type="submit"
                to="/register"
                id="main-font"
                onClick={handleMenuItemClick}
              >
                Register
              </Link>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
